/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
import React, { forwardRef } from 'react';
import cx from 'classnames';

import Maybe from 'react-maybe';

export const Headline = forwardRef(function Headline(
    { children, variant = Variants.DARK, className, style },
    ref
) {
    return (
        <h1
            style={style}
            ref={ref}
            className={cx('typo typo--headline', variant, className)}
        >
            {children}
        </h1>
    );
});
export const Title = forwardRef(function Title(
    { children, variant = Variants.DARK, className, style },
    ref
) {
    return (
        <h2
            style={style}
            ref={ref}
            className={cx('typo', 'typo--title', variant, className)}
        >
            {children}
        </h2>
    );
});
export const Subheader = forwardRef(function Subheader(
    { children, variant = Variants.DARK, className, style, dangerouslySetInnerHTML },
    ref
) {
    if (dangerouslySetInnerHTML) {
        return (
            <h3
                style={style}
                ref={ref}
                className={cx('typo typo--subheader', variant, className)}
                dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            />
        );
    }
    return (
        <h3
            style={style}
            ref={ref}
            className={cx('typo typo--subheader', variant, className)}
        >
            {children}
        </h3>
    );
});
export const Menu = forwardRef(function Menu(
    { children, variant = Variants.DARK, className, style },
    ref
) {
    return (
        <span
            style={style}
            ref={ref}
            className={cx('typo typo--menu', variant, className)}
        >
            {children}
        </span>
    );
});
Menu.Bold = forwardRef(function MenuBold(
    { children, variant = Variants.DARK, className, style },
    ref
) {
    return (
        <span
            style={style}
            ref={ref}
            className={cx('typo typo--menu typo--menu-bold', variant, className)}
        >
            {children}
        </span>
    );
});
export const Body = forwardRef(function Body(
    {
        children,
        variant = Variants.DARK,
        className,
        style,
        dangerouslySetInnerHTML
    },
    ref
) {
    if (dangerouslySetInnerHTML) {
        return (
            <span
                style={style}
                ref={ref}
                className={cx('typo typo--body', variant, className)}
                dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            />
        );
    }
    return (
        <span
            style={style}
            ref={ref}
            className={cx('typo typo--body', variant, className)}
        >
            {children}
        </span>
    );
});
Body.Bold = forwardRef(function BodyBold(
    { children, variant = Variants.DARK, className, style },
    ref
) {
    return (
        <span
            style={style}
            ref={ref}
            className={cx('typo typo--body', 'typo--body-bold', variant, className)}
        >
            {children}
        </span>
    );
});
export const Caption = forwardRef(function Caption(
    {
        children,
        variant = Variants.LIGHT,
        className,
        style,
        dangerouslySetInnerHTML
    },
    ref
) {
    if (dangerouslySetInnerHTML) {
        return (
            <span
                style={style}
                ref={ref}
                className={cx('typo typo--caption', variant, className)}
                dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            />
        );
    }
    return (
        <span
            style={style}
            ref={ref}
            className={cx('typo typo--caption', variant, className)}
        >
            {children}
        </span>
    );
});

export const Link = forwardRef(function Link({ children, variant = Variants.LINK, onClick, url, style, target, rel }, ref) {
    return (
        <Maybe
            of={url}
            either={(
                <a href={url} target={target || '_self'} rel={rel}>
                    <Body style={style} variant={variant}>{children}</Body>
                </a>
            )}
            orElse={(
                <span ref={ref} onClick={onClick}>
                    <Body style={style} variant={variant}>{children}</Body>
                </span>
            )}
        />
    );
});

export const Variants = {
    LINK: 'typo--link',
    WHITE: 'typo--white',
    LIGHT: 'typo--light',
    DARK: 'typo--dark',
    SUCCESS: 'typo--success',
    INFO: 'typo--info',
    WARNING: 'typo--warning',
    ERROR: 'typo--error'
};
